import { FormValidationRule } from "../types";

const giinPattern = new RegExp(/^[A-NP-Z0-9]{6}\.[A-NP-Z0-9]{5}\.(LE|SL|ME|BR|SP|SF|SD|SS|SB)\.[0-9]{3}$/i);

const validGIIN: FormValidationRule = (control, value) => {

    let valid = true;
    let invalidGiinErrorMessage = "";

    if ( control.type === 'boi_giin' ) {
        const validStructure = value && giinPattern.test(value) && ( value.toUpperCase() === value );
        if ( !validStructure ) {
            valid = false;
            if ( control.form_field_tab_boi_giin_invalid ) {
                invalidGiinErrorMessage = control.form_field_tab_boi_giin_invalid;
            } else {
                invalidGiinErrorMessage = "GIIN field must have the following format: XXXXXX.XXXXX.XX.XXX";
            }
        }
    }
    return [valid, invalidGiinErrorMessage];
};

export default validGIIN;